/**
 * EX.CO video player configuration (WFW-6716).
 */

/**
 * TBL feature-toggle keys that gate the EX.CO player.
 */
export const EXCO_FEATURE_FLAGS = {
	OVERRIDE: "ExcoOverride",
	MOBILE: "ExcoMobile",
	DESKTOP: "ExcoDesktop",
	DISABLE_THIRD_PARTY: "DisableThirdParty",
};

/**
 * Countries in which the EX.CO player is allowed to render.
 */
export const EXCO_GEO_ALLOWLIST = ["US", "CA", "GB"];

/**
 * EX.CO player IDs, keyed by stage.
 *
 * Prod and non-prod currently share the same player ID.
 * TODO(WFW-6716): replace `nonProd` with a dedicated non-prod player ID once
 * EX.CO provides one.
 */
const EXCO_PLAYER_IDS = {
	prod: "bbb9445b-7678-4409-9b9e-34d2ac313169",
	nonProd: "bbb9445b-7678-4409-9b9e-34d2ac313169",
};

/**
 * Returns the EX.CO player ID for the current stage.
 * @returns {string} The player ID
 */
export const getExcoPlayerId = () =>
	process.env.STAGE === "prod"
		? EXCO_PLAYER_IDS.prod
		: EXCO_PLAYER_IDS.nonProd;
